import { useAuth } from "@clerk/clerk-react";

import useAxios from "../../hooks/use-axios";
import LoadingSpinner from "../../components/UI/LoadingSpinner";
import Card from "../../components/UI/Card";
import styles from "../styles.module.css"

const NotVerified = () => {
    const { getToken } = useAuth();
    const { request, loading } = useAxios(`${process.env.REACT_APP_BACKEND}/api/auth/resend-email`, "post", {})

    const handleClick = async () => {
        const token = await getToken();
        request({ token });
    }

    return <div className={`${styles.background} h-screen relative flex justify-center items-center`}>
        <Card>
            <div className="mx-0 sm:mx-5 my-7 flex flex-col justify-center items-center">
                <h2 className="font-roboto text-4xl uppercase font-bold tracking-wider text-green-900 mb-10">Email not verified</h2>
                <button onClick={handleClick} className="bg-green-800 text-white w-40 sm:w-80 h-7 sm:h-10 mx-5 text-lg sm:text-xl rounded-full">{loading ? <LoadingSpinner /> : "Re-send verification email"}</button>
            </div>
        </Card>
    </div>
}

export default NotVerified;